import React, {  useState,useRef, useEffect } from 'react';
import axios from 'axios';
import { getUserId,aPIURL,getUser,websiteUrl } from '../../utils/common';
import Modal from '../ModalSale';
import ReactPaginate from "react-paginate";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useReactToPrint } from 'react-to-print';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import Switch from "react-switch";
import EditGeoFence from './EditGeoFence';
//import Enumerate from "linq";
import { validationLatitudeLongitude } from "validation-latitude-longitude";


const GeoFenceAlert = () => 
{ 
  
  const fileType ="xlsx";
  const [SNo,setSNo]=useState("");
  const API_URL=aPIURL();
  const webUrl=websiteUrl();
  const tableRef = useRef(null);
  let [advPriority, setAdvPriority] = useState("");  
  let [advAlertType, setAdvAlertType] = useState("");
  const [statusId, setStatusId]= useState(0);
  const [order, setOrder] = useState("ASC");
  const [number, setNumber] = useState(1); // No of pages
  const [postPerPage] = useState(10);
  const [post, setPost] = useState([]);
  const AccountID =getUserId(); 
  const [inputs, setInputs] = useState({});
  const [dID, setDID]  = useState(0);
   const [alertType, setAlertType]=useState("N/A");
  const [alertTypeId, setAlertTypeId]=useState(0);
  const [showDetails,setShowDetails ]  = useState(false);
  const [vehicleData,setVehicleData] =useState([]);
  const[distanceValue,setDistanceValue]=useState(0);
  const [vehicleNo,setVehicleNo]=useState(0);
  const UserName=getUser();
  const [switchValue, setSwitchValue]= useState(true);
  const [showAlertSettingDetails,setShowAlertSettingDetails ]  = useState(false);
  const [showEditAlertSettingDetails,setShowEditAlertSettingDetails ]  = useState(false);
  const [latitude, setLatitude] = useState("0");
  const [longitude, setLongitude] = useState("0");
  const [inputsEdit, setInputsEdit] = useState({});
  const strUrl=webUrl+`geofencealert.html?AccountID=${AccountID}`;
  let streditUrl='';
  const [alertId, setAlertId]=useState(0);
  const [account_id,setAccount_id]=useState();
  const [alert_id,setAlert_id]=useState();
  let editgeofenceinfo={accountid:account_id,alertid:alert_id}  


 useEffect(() => 
   {    
             FillGrid(statusId);
             
   }, []);
   
   const lastPost = number * postPerPage;
   const firstPost = lastPost - postPerPage;
   const currentPost = post.slice(firstPost, lastPost);
   const PageCount = Math.ceil(post.length / postPerPage);
   let gurl=API_URL;

const FillGrid=(status_Id)=>
{
    const Account_ID = getUserId(); 
    if(SNo === '') 
    {
         gurl=API_URL+`GeofenceSettings?AccountID=${AccountID}&Type_ID=${status_Id}&Vehicle_No=0`;
    }
    else
    {
          gurl=API_URL+`GeofenceSettings?AccountID=${AccountID}&Type_ID=${status_Id}&Vehicle_No=${SNo}`;
    }
         
       
      setPost([]);
    
      axios.post(gurl).then(response => 
        {  
           setPost(response.data.data);
           console.log(response.data.data);
                  
        }).catch(function(error) 
        {
              console.log(error.message);
        
        }); 
      
}  
const ChangeAlertId= (e) => {
         
         setAlertTypeId(e.target.value);         
         inputs.thresholdValue=1;
}
const NewAlertSettingModal = () => 
{      
       setInputs({});
       setDID(0);
       setAlertTypeId(0);
       setShowDetails(true); 
       const vurls=API_URL+`VehicleList/?AccountID=${AccountID}&TypeID=0`;    //Bind Drop Down for vehicle List
       
       axios.get(vurls).then(response =>
             {                  
                    const updatedList =  response.data.data.filter((curElem) => {
                    return curElem.status === "Enabled";
              });   
              console.log("Faiz-vehicleList");
              console.log(updatedList);
                   setVehicleData(updatedList);                    

             }).catch(function(error) 
             {  
                  console.log(error.message); 
             });                            
            
}

const sorting=(col)=>
  {
    try
    {
      if(order==="ASC")
      {
              const sorted=[...post].sort((a,b)=>
              a[col].toLowerCase() > b[col].toLowerCase() ? 1: -1
              );
              setPost(sorted);
              setOrder("DSC");
      }
      if(order==="DSC")
      {
              const sorted=[...post].sort((a,b)=>
              a[col].toLowerCase() < b[col].toLowerCase() ? 1: -1
              );
              setPost(sorted);
              setOrder("ASC");
      }
    }
    catch(error) 
    {
      console.log(error.message);
    }  
            
  }
const ResetList=()=>
{
    setSNo('');
    const Account_ID = getUserId(); 
    gurl=API_URL+`GeofenceSettings?AccountID=${AccountID}&Type_ID=${statusId}&Vehicle_No=0`;
    setPost([]);
    axios.post(gurl).then(response => 
        {  
           setPost(response.data.data);
                  
        }).catch(function(error) 
        {
              console.log(error.message);        
        });    
}

const ChangePage = ({ selected }) => {
        
        setNumber(selected+1);        
  };


const handlePrint = useReactToPrint({

  documentTitle: "Alert Details",
  onBeforePrint: () => console.log("before printing..."),
  onAfterPrint: () => console.log("after printing..."),
  removeAfterPrint: true,
});
const exportStatus = e => {
 
  setStatusId(e.target.value);
  const value = e.target.value; 
  FillGrid(e.target.value);
}
const exportToCSV=()=>
  {
    const newPost = post.map(({ accountID,deviceID,id, ...rest }) => rest);
     const ws= XLSX.utils.json_to_sheet(newPost);        
     var wscols = [
        {wch:5} ,
        {wch:20},
        {wch:20},
        {wch:15},
        {wch:15},
        {wch:60},
        {wch:20},         
        {wch:20}
    ];
 
    var wsrows = [
       {hpx: 30}
    ];
    
    ws['!cols'] = wscols;
    ws['!rows']=wsrows;         
    let Heading = [['S.No.','Vehicle Number','Geofence Name','Status','Priorities','Description','Created ON','Created By']];
    const wb={Sheets:{Alerts:ws},SheetNames:["Alerts"]};
    XLSX.utils.sheet_add_aoa(ws, Heading);     
    const excelBuffer= XLSX.write(wb,{bookType:"xlsx",type:"array"});
    const data= new Blob([excelBuffer],{type:fileType});
    FileSaver.saveAs(data,"AvtGeoFenceAlertsReport.xlsx");
   }
const exportDownload = e => 
{  
  
  const value = e.target.value; 
  
  if(value==="Excel")
  {
        exportToCSV();   
  }
  if(value==="PDF")
  {
        handlePrint(null, () => tableRef.current);
  }
}
const changeHandler = (e) => 
{   
    setSNo(e.target.value)
} 
const FilterGrid =() => 
{
     FillGrid(statusId);     
}
const changeVHandler = (event) => {

      const name = event.target.name;
      const value = event.target.value;
      setInputs(values => ({...values, [name]: value}))   
}

const changeRadiuseHandler=(e)=>
{
        setDistanceValue(e.target.value);
}

const showSettingDetailsModal = (index) => {
       
            setShowAlertSettingDetails(true);
            const vurls=API_URL+`GeofenceSettingByID/?AlertID=${index}`;            
            
            axios.post(vurls).then(response => {                             

             setVehicleNo(response.data.data[0].vehicleNumber);
             setAlertTypeId(response.data.data[0].alertTypeID);
             setAlertType(response.data.data[0].alertType);
             setLatitude(response.data.data[0].latitude);
             setLongitude(response.data.data[0].longitude);
             setDistanceValue(response.data.data[0].distance);                     
                    
         }).catch(function(error) 
         {
           console.log(error.message);
         });    
          
}
const showEditSettingDetails = (index) => {
        
        setAccount_id(AccountID);
        setAlert_id(index);
        setAlertId(index);
        setShowEditAlertSettingDetails(true);
        setDistanceValue(0);  
}
const deleteGeofence=(index)=> {

  if(window.confirm('Do you want to disable the Alert?'))
  {
    const ddurls=API_URL+`GeofenceDelete?AlertID=${index}&ActionType=1`;
        
    axios.post(ddurls).then(response => {
    if(response.data.validStatus === false)
    {
          toast.error(response.data.message); 
    }
    else
    {
          toast.success(response.data.message);
          FillGrid(statusId);
    }        
  }).catch(function(error) 
  {
    console.log(error.message);
  }); 
} 
else 
{
        toast.error('Delete operation canceled.');
}
}
const closeGeoFenceModal=()=>{

      FillGrid(statusId);
      setShowDetails(false); 
      setShowAlertSettingDetails(false);
      setShowEditAlertSettingDetails(false);
}

const closeEditGeoFenceModal=()=>{

      FillGrid(statusId);
      setShowDetails(false); 
      setShowAlertSettingDetails(false);
      setShowEditAlertSettingDetails(false);
}
const closeModal = () => 
{     
      FillGrid(statusId);
      setShowDetails(false); 
      setShowAlertSettingDetails(false);
      setShowEditAlertSettingDetails(false);            
}   
const changeEDHandler = (event) => 
{  
  const name = event.target.name;
  const value = event.target.value;
  setInputsEdit(values => ({...values, [name]: value}))
}
const handleSwitchChange=(switchValue)=>
{
       setSwitchValue(switchValue);    
}
const UpdateAlert=()=>
{
        
       if(alertTypeId==3 && (inputsEdit.latitude === null || inputsEdit.latitude === ''))
        {
                  toast.error("Please enter latitude.");
                  return;
        }  
        else if(alertTypeId ===3 && (inputsEdit.longitude === null || inputsEdit.longitude === ''))
        {
                  toast.error("Please enter longitude.");
                  return;
        }
        else if(alertTypeId ===3 && !(validationLatitudeLongitude.latitude(inputsEdit.latitude)))
        {
                    toast.error("Please enter valid latitude.");
                    return;
        }  
        else if(alertTypeId ===3 && !(validationLatitudeLongitude.longitude(inputsEdit.longitude)))
        {
                    toast.error("Please enter valid longitude.");
                    return;
        }
        else if(alertTypeId ===3 && (distanceValue===0))
        {
                  toast.error("Please enter radius.");
                  return;
        }    
        else if(inputsEdit.alerttitle === null || inputsEdit.alerttitle === '')
        {
                    toast.error("Please enter alert title.");
                    return;
        }
        else  
        {     //update Device Details
             const params = JSON.stringify({

                               "id": alertId,
                               "accountID": AccountID,
                               "vehicleID": vehicleNo,
                               "alertTypeID": 3,
                               "name": inputsEdit.alerttitle,
                               "latitude": inputsEdit.latitude==null?"0":inputsEdit.latitude,
                               "longitude": inputsEdit.longitude==null?"0":inputsEdit.longitude,
                               "rediuse": distanceValue,
                               "threshold": 0,
                               "is_Notification": true,
                               "is_SMS": true,
                               "iS_Active": switchValue,
                               "createdBy": UserName       
              
          });
          
          axios.post(API_URL+'Geofence/', params, 
          {
               "headers": 
               {
                      "content-type": "application/json",    
               },
          })
            .then(function (response) 
            {
                 if(!response.data.validStatus)
                 {
                         
                         toast.error(response.data.message);
                         return;
                 }
                 else
                 {         
                       toast.success(response.data.message);
                       setInputsEdit({});                      
                 }                    
                 
            }).catch(function (error) 
            {
                    toast.error(error.message);                        
            });     
        }
}

return (       
 <>     
 {/*Add New Alert Settings Popup STARTS*/}          
<Modal isOpen={showDetails} >  
<div  class="modal-header">
     <h5 className='modal-title'>GeoFence Alert Settings</h5>
     <button type="button" class="btn-close" onClick={closeModal}></button>
</div>
<div class="modal-body"> 
     <iframe width="1100px" height="750px" src={strUrl}  title="ShowGeoFenceInsertIFR" ></iframe>                     
     </div>                   
</Modal> 
 {/*Add New Alert Settings Popup ENDS*/}    
 {/*Show Details Popup STARTS*/}      
<Modal isOpen={showAlertSettingDetails} >  
              <div  class="modal-header">
              <h5 className='modal-title'>GeoFence Details</h5>
              <button type="button" class="btn-close" onClick={closeGeoFenceModal}></button>
              </div>
              <div class="modal-body"> 
              <div class="row">
              <div class="col-sm-6 col-md-4 form-group">&nbsp;
              <b>Vehicle# :</b><br/>
             <span> {vehicleNo} </span>
		          </div>  
              <div class="col-sm-6 col-md-4 form-group">&nbsp;
              <b>Alert Title :</b> <br/>          
              <span> {alertType} </span>
		          </div>  
              <div class="col-sm-6 col-md-4 form-group" >&nbsp;
              <b>Latitude :</b> <br/>          
              <span> {latitude} </span>
              </div> 
              <div class="col-sm-6 col-md-4 form-group" >&nbsp;
              <b>Longitude :</b> <br/>          
              <span> {longitude} </span>
              </div> 
              <div class="col-sm-6 col-md-4 form-group" >&nbsp;
              <b>Radius (in Meters) :</b> <br/>          
              <span> {distanceValue} </span>
              </div>              
              </div>                        
              </div>
                   
</Modal>   
<Modal isOpen={showEditAlertSettingDetails} >  
            <div  class="modal-header">
            <h5 className='modal-title'>Edit GeoFence</h5>
            <button type="button" class="btn-close" onClick={closeEditGeoFenceModal}></button>
            </div>
            <div class="modal-body">               
            <EditGeoFence  EditGeofenceobj = {editgeofenceinfo}/>                         
            </div>                    
</Modal>            
{/*Show Details Popup ENDS*/}  
   <div className="top-bar clearfix">
      <div className="row">       
       <div className="col-md-4">
       <h2> GeoFence Settings</h2>           
         </div>
         <div className="col-md-8 text-right">
         <button type="submit" id="Save" onClick={() =>NewAlertSettingModal()} className="btn btn-new"> New </button>
          <select onChange={exportStatus} className="btn btn-primary" name="DStatus" value={statusId} >               
          <option value={"0"}>All</option>
          <option value={"1"}>Enabled</option>
          <option value={"2"}>Disabled</option>   
          <option value={"3"}>Deleted</option>                  
          </select> 
          <select onChange={exportDownload}  className="btn btn-primary" name="DDownload">
          <option value={"Download"}>Download</option>    
          <option value={"Excel"}>Excel</option>    
          <option value={"PDF"}>PDF</option>                     
          </select>
         </div>
       </div>
      </div>    
  <div className="container-fluid p-3">
  {/* Filter data start */}
  <div class="card mb-3 shadow no-border border-0">
  <div class="card-body">
    <div class="row align-items-end">
     <div class="col-sm-3 col-lg-2">Vehicle#<input type="text" class="form-control" tabindex="1" id="txtTripNumber" value={SNo} onChange={changeHandler} maxlength="50"/>
    </div>     
    <div class="col-sm-4 col-lg-2">
      <button type="button" class="btn btn-primary2 mt-20" tabindex="6" id="btnSearchNew" onClick={FilterGrid} >Search</button>
      <button type="button" class="btn btn-secondary mt-20" id="btnResetList" tabindex="7" onClick={ResetList}>Reset
      </button></div>
      </div>
  </div></div>
  {/* Filter data end  */}
  <div class="card mb-3 shadow no-border border-0">
  <div class="card-body p-0">
          <table ref={tableRef} class="table table-striped table-bordered table-hover" style={{width:"100%"}}>
          <thead>
            <tr>
                <th width="5%"  style={{textAlign:"center","cursor": "pointer"}}>S.No. </th>
                <th width="10%" onClick={()=>sorting("vehicleNumber") } style={{textAlign:"center","cursor": "pointer"}}>Vehicle Number  &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                <th width="7%" onClick={()=>sorting("priorities") } style={{textAlign:"center","cursor": "pointer"}}>Priorities &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                <th width="15%" onClick={()=>sorting("alertType") } style={{textAlign:"center","cursor": "pointer"}}> Geofence Name  &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                 <th width="30%" onClick={()=>sorting("smsContent") } style={{textAlign:"center","cursor": "pointer"}}>Description &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                <th width="8%" onClick={()=>sorting("status") } style={{textAlign:"center","cursor": "pointer"}}>Status &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                <th width="10%" onClick={()=>sorting("CreatedBy") } style={{textAlign:"center","cursor": "pointer"}}>Created By &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                <th width="10%" onClick={()=>sorting("CreatedON") } style={{textAlign:"center","cursor": "pointer"}}>Created ON &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                <th style={{textAlign:"center"}} width="13%">Action</th>
            </tr>
         </thead>
        <tbody>
        {currentPost.map((devdata) => {
        return (
            <>
            <tr key={devdata.id}>
              <td style={{textAlign:"center"}}>{devdata.alertID}</td>
              <td>{devdata.vehicleNumber}</td>
              <td  class={devdata.priorities==="Critical"?"text-danger":(devdata.priorities==="Low"?"text-success":"text-warning")}><b>{devdata.priorities}</b></td>
              <td>{devdata.alertType}</td>
              <td style={{textAlign: "left"}}>{devdata.smsContent}</td>
              <td style={{textAlign:"center"}}>{devdata.status}</td>
              <td style={{textAlign:"center"}}>{devdata.createdBy}</td>
              <td style={{textAlign:"center"}}>{devdata.createdON}</td>      
              <td style={{textAlign:"center", fontSize:"14px"}}>   
              <i onClick={() => showSettingDetailsModal(devdata.id)} style={{ color:"green", cursor:'pointer'}} className="fa-solid fa-list" title="View Details"></i>
              &nbsp;&nbsp; <i onClick={() => showEditSettingDetails(devdata.id)} style={{ color:"rgb(13, 110, 253)", cursor:'pointer'}} className={devdata.status==="Deleted"?"display:none":"display:block  fa-solid fa-pen-to-square"}  title="Update Details"></i>
              &nbsp;&nbsp;<i onClick={() => deleteGeofence(devdata.id)} style={{ color:"red", cursor:'pointer'}}  className={devdata.status==="Deleted"?"display:none":"display:block  fa-solid fa-trash"}  title="Delete"></i>
              </td>                
            </tr>
            </>
            );
              })}
            </tbody>
        </table>
        <ReactPaginate  previousLabel={"<<"}  nextLabel={">>"}  pageCount={PageCount}  onPageChange={ChangePage}  disableInitialCallback={true} initialPage={0}  containerClassName={'pagination justify-content-end'} pageClassName={'page-item'} pageLinkClassName={'page-link'}
        previousClassName={'page-item'} previousLinkClassName={'page-link'}  nextClassName={'page-item'}  nextLinkClassName={'page-link'} breakClassName={'page-item'}  breakLinkClassName={'page-link'} activeClassName={'active'}></ReactPaginate>
        </div> </div></div>
        <ToastContainer position="bottom-right" autoClose={4000} theme="light"/>              
        </>
)};    
export default GeoFenceAlert;